<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="12">
        <h-three title="Custom" /><!-- '2021-09-28T18:23:59.183Z' -->
        <datetime-picker type="custom" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
      </flex-col>
      <flex-col :span="12">
        <h-three title="Datetime" />
        <datetime-picker type="datetime" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
      </flex-col>
      <flex-col :span="12">
        <h-three title="Date" />
        <datetime-picker type="date" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
      </flex-col>
      <flex-col :span="12">
        <h-three title="Time" />
        <datetime-picker type="time" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageDatetimePicker'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/datetime-picker.vue